// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__Ro1Rm","selected":"Chip_selected__1rIxH"};